export default __webpack_public_path__ + "static/media/Web_Hero_Image@3x.c0746813.png";